import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,0A10.13,10.13,0,0,0,0,10.25,10.24,10.24,0,0,0,6.84,20a0.51,0.51,0,0,0,.68-0.49c0-.24,0-0.89,0-1.74-2.78.62-3.37-1.37-3.37-1.37A2.7,2.7,0,0,0,3,14.87c-0.91-.64.07-0.62,0.07-0.62A2.11,2.11,0,0,1,4.63,15.3a2.1,2.1,0,0,0,2.91.85,2.21,2.21,0,0,1,.63-1.37C6,14.53,3.62,13.65,3.62,9.72A4,4,0,0,1,4.65,7a3.77,3.77,0,0,1,.1-2.71S5.59,4,7.5,5.3a9.25,9.25,0,0,1,5,0C14.41,4,15.25,4.25,15.25,4.25A3.77,3.77,0,0,1,15.35,7a4,4,0,0,1,1,2.75c0,3.94-2.34,4.81-4.57,5.06a2.48,2.48,0,0,1,.68,1.9c0,1.37,0,2.48,0,2.81a0.5,0.5,0,0,0,.69.49A10.24,10.24,0,0,0,20,10.25,10.13,10.13,0,0,0,10,0Z"
});

var SvgGithub = function SvgGithub(props) {
  return _ref;
};

export default SvgGithub;